import { faWarning } from "@fortawesome/free-solid-svg-icons";
import Icon from "components/components/Icon/Icon";
import React, { ReactNode } from "react";

import { StyledWarningContainer } from "./style";

interface WarningContainerProps {
  children: ReactNode;
}

const WarningContainer: React.FC<WarningContainerProps> = ({ children }) => (
  <StyledWarningContainer>
    <Icon iconName={faWarning} colour="darkOrange" />
    <span>{children}</span>
  </StyledWarningContainer>
);

export default WarningContainer;
